@if (label()) {
    <form-label [id]="id() + '-label'" [forId]="id() + '-datepicker'" [label]="label()"> </form-label>
}

<p-buttongroup [class.fluid]="fluid()">
    @for (option of options(); track option.value; let first = $first, last = $last) {
        <btn
            [id]="option[optionValue() || '']"
            [label]="option[optionLabel() || '']"
            [icon]="option.icon"
            [iconPos]="option.iconPos"
            [severity]="value() === option.value ? 'primary' : 'secondary'"
            [size]="size()"
            [class.btn-select]="true"
            [class]="getButtonClass(option, first, last)"
            [disabled]="disabled()"
            [glueLeft]="first"
            [glueRight]="last"
            (onClick)="changeSelectedValue(option)"></btn>
    }
</p-buttongroup>
